"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.YE = void 0;
exports.YE = {
    numericCode: '887',
    alpha2Code: 'YE',
    alpha3Code: 'YEM',
    englishName: {
        short: 'Yemen',
        full: 'the Republic of Yemen',
    },
    names: {
        full: {
            en: 'the Republic of Yemen',
            fr: 'la République du Yémen',
            ar: 'Al Yaman',
        },
        short: {
            en: 'Yemen',
            fr: 'Yémen (le)',
            ar: 'Al Yaman',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'ar',
            languageAlpha3Code: 'ara',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'YE-SA': {
            numericCode: '887',
            code: 'YE-SA',
            category: {
                id: '142',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'municipalité',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Amānat al ‘Āşimah [city]',
            },
        },
        'YE-AB': {
            numericCode: '887',
            code: 'YE-AB',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Abyan',
            },
        },
        'YE-AD': {
            numericCode: '887',
            code: 'YE-AD',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: '‘Adan',
            },
        },
        'YE-AM': {
            numericCode: '887',
            code: 'YE-AM',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: '‘Amrān',
            },
        },
        'YE-BA': {
            numericCode: '887',
            code: 'YE-BA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Bayḑā’',
            },
        },
        'YE-DA': {
            numericCode: '887',
            code: 'YE-DA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Aḑ Ḑāli‘',
            },
        },
        'YE-DH': {
            numericCode: '887',
            code: 'YE-DH',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Dhamār',
            },
        },
        'YE-HD': {
            numericCode: '887',
            code: 'YE-HD',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ḩaḑramawt',
            },
        },
        'YE-HJ': {
            numericCode: '887',
            code: 'YE-HJ',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ḩajjah',
            },
        },
        'YE-HU': {
            numericCode: '887',
            code: 'YE-HU',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Ḩudaydah',
            },
        },
        'YE-IB': {
            numericCode: '887',
            code: 'YE-IB',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ibb',
            },
        },
        'YE-JA': {
            numericCode: '887',
            code: 'YE-JA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Jawf',
            },
        },
        'YE-LA': {
            numericCode: '887',
            code: 'YE-LA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Laḩij',
            },
        },
        'YE-MA': {
            numericCode: '887',
            code: 'YE-MA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ma’rib',
            },
        },
        'YE-MR': {
            numericCode: '887',
            code: 'YE-MR',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Mahrah',
            },
        },
        'YE-MW': {
            numericCode: '887',
            code: 'YE-MW',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Maḩwīt',
            },
        },
        'YE-RA': {
            numericCode: '887',
            code: 'YE-RA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Raymah',
            },
        },
        'YE-SD': {
            numericCode: '887',
            code: 'YE-SD',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Şāʻdah',
            },
        },
        'YE-SH': {
            numericCode: '887',
            code: 'YE-SH',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Shabwah',
            },
        },
        'YE-SN': {
            numericCode: '887',
            code: 'YE-SN',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Şanʻā’',
            },
        },
        'YE-SU': {
            numericCode: '887',
            code: 'YE-SU',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Arkhabīl Suquţrá',
            },
        },
        'YE-TA': {
            numericCode: '887',
            code: 'YE-TA',
            category: {
                id: '386',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Tāʻizz',
            },
        },
    },
    cities: [
        {
            name: 'Zinjibār',
            subdivision: 'Abyan',
        },
        {
            name: 'Zabīd',
            subdivision: 'Muḩāfaz̧at al Ḩudaydah',
        },
        {
            name: 'Yarīm',
            subdivision: 'Ibb',
        },
        {
            name: 'Ta‘izz',
            subdivision: 'Ta‘izz',
        },
        {
            name: 'Sayyān',
            subdivision: 'Sanaa',
        },
        {
            name: 'Sanaa',
            subdivision: 'Sanaa',
        },
        {
            name: 'Saḩar',
            subdivision: 'Sanaa',
        },
        {
            name: "Sa'dah",
            subdivision: 'Şa‘dah',
        },
        {
            name: "Ma'rib",
            subdivision: 'Ma’rib',
        },
        {
            name: 'Laḩij',
            subdivision: 'Laḩij',
        },
        {
            name: 'Ibb',
            subdivision: 'Ibb',
        },
        {
            name: 'Ḩajjah',
            subdivision: 'Ḩajjah',
        },
        {
            name: 'Dhī as Sufāl',
            subdivision: 'Ibb',
        },
        {
            name: 'Dhamār',
            subdivision: 'Dhamār',
        },
        {
            name: 'Bayt al Faqīh',
            subdivision: 'Muḩāfaz̧at al Ḩudaydah',
        },
        {
            name: 'Bājil',
            subdivision: 'Muḩāfaz̧at al Ḩudaydah',
        },
        {
            name: 'Ataq',
            subdivision: 'Shabwah',
        },
        {
            name: '‘Amrān',
            subdivision: 'Omran',
        },
        {
            name: 'Al Mukallā',
            subdivision: 'Muḩāfaz̧at Ḩaḑramawt',
        },
        {
            name: 'Al Ḩudaydah',
            subdivision: 'Muḩāfaz̧at al Ḩudaydah',
        },
        {
            name: 'Al Ḩazm',
            subdivision: 'Al Jawf',
        },
        {
            name: 'Al Bayḑā’',
            subdivision: 'Al Bayḑāʼ',
        },
        {
            name: 'Aden',
            subdivision: 'Aden',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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